module.exports = __webpack_public_path__ + "static/media/website.557a13c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Teafloor/website.jpg
// module id = 368
// module chunks = 0